import React from "react";
import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import {
  ListResponseOfTimeZone,
  TimeZone,
} from "services/KnowfullyAdminClient";
import useGlobalContext from "hooks/globalData";
import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";

type SelectTimeZoneProps = Omit<
  AutocompleteWithQueryProps<TimeZone>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectTimeZone = ({
  ...rest
}: SelectTimeZoneProps) => {
  const { formatMessage: t } = useIntl();
  const { timeZoneService } = useGlobalContext();

  const fetchedTimeZones = useQuery<ListResponseOfTimeZone>(
    [
        "TimeZones"
    ],
    () =>
        timeZoneService.getTimeZones()
    );

  return (
    <AutocompleteWithQuery
      {...rest}
      labelField="id"
      fetchedData={fetchedTimeZones}
      failMessage={t({ id: "selectTimeZoneFetchFailed" })}
    />
  );
};

export default SelectTimeZone;
